import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pay-just-now',
  templateUrl: './pay-just-now.component.html',
  styleUrls: ['./pay-just-now.component.scss']
})
export class PayJustNowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
